import { tsValidateArray, tsValidateRegexp, tsValidateUniqueId, tsValidator_nonMandatoryString } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '../common.js';
const Validator_ModifiableProps = {
    label: tsValidateRegexp(/^[\w\W\s&/,\\-]{2,100}$/),
    tagIds: tsValidateArray(tsValidateUniqueId),
    _origin: tsValidator_nonMandatoryString
};
const Validator_GeneratedProps = {};
export const DBDef_Tag = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1'],
    dbKey: 'tags',
    entityName: 'Tag',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'tag'
    },
    backend: {
        name: 'tags'
    },
    dependencies: {
        tagIds: {
            dbKey: 'tags',
            fieldType: 'string[]'
        }
    }
};
//# sourceMappingURL=db-def.js.map